import { useTranslation } from "react-i18next";

export const AgentServiceClaimNavigationCardData = () => {
  const { t } = useTranslation();
  return [
    {
      icon: "#ui-icon-payment",
      title: t("AgentClaims-cardTitle1"),
      desc: t("AgentClaims-cardDesc1"),
      url: "/commissions",
    },
    {
      icon: "#ui-icon-payment",
      title: t("AgentClaims-cardTitle2"),
      desc: t("AgentClaims-cardDesc2"),
      url: "/help",
    },
    {
      icon: "#ui-icon-payment",
      title: t("AgentClaims-cardTitle3"),
      desc: t("AgentClaims-cardDesc3"),
      url: "/profile",
    },
  ];
};
